<template>
  <!-- 대표자 본인확인(읽기 전용) — 줄은 `utils/ceoVerification` 이 만든다. 블록이 없으면(확인한 적 없음·대행 계정) 자리째 그리지 않는다 -->
  <el-col v-if="line" :span="24">
    <el-form-item class="ceo-verification">
      <span>{{ line.text }}</span>
      <span v-if="line.stale" class="ceo-verification__stale"> · {{ $t(line.stale) }}</span>
    </el-form-item>
  </el-col>
</template>

<script>
import { ceoVerificationLine } from '@/utils/ceoVerification'

/**
 * 매장·사업장 「사업자 정보」의 대표자 확인 줄 — 매장(`store/BusinessInfoFormPanel`)과 사업장 화면 셋(`CustInfoView`·`CustListView`·
 * `CustTreeView`)이 대표자명 칸 아래 같은 줄을 쓴다. 폼의 줄(`el-row`) 안에 한 칸 전체(`el-col` 24)로 선다.
 */
export default {
  name: 'CeoVerificationLine',
  props: {
    /** 상세 응답의 `ceoVerification` — 없으면 `null`·`undefined` */
    block: { type: Object, default: null },
  },
  computed: {
    line() {
      return ceoVerificationLine(this.block)
    },
  },
}
</script>

<style scoped>
.ceo-verification {
  color: var(--color-text-secondary);
}
.ceo-verification__stale {
  color: var(--color-warning);
}
</style>
